import {Component, EventEmitter, Input, Output} from '@angular/core';
import {EntityCollectionGetByIdService} from '../../service/entityCollectionGetByIdService';
import {HttpModelConverter} from '../../converter/httpModel.converter';
import {BaseView} from '../../view/base.view';
import {AbstractFindOneByIdService} from '../../service/v2/service/findone/abstractFindOneById.service';

@Component({
    selector: 'app-view-by-id-default',
    templateUrl: './view-by-id-default.component.html',
})
export class ViewByIdDefaultComponent<Model, Converter extends HttpModelConverter<Model>> extends BaseView {

    @Input() id: number;
    @Input() findByIdService: EntityCollectionGetByIdService<Model, Converter> | AbstractFindOneByIdService<any, Model>;
    @Output() entityLoaded = new EventEmitter<Model>();

    constructor() {
        super();
    }

    entityLoadedInComponent(entity: Model) {
        if (this.entityLoaded) {
            this.entityLoaded.emit(entity);
        }
    }
}
